// extracted by mini-css-extract-plugin
export default {"tabs":"TabNavigation_tabs__drk4M","tab":"TabNavigation_tab__5RszC","redDot":"TabNavigation_redDot__dnW4g","tabActive":"TabNavigation_tabActive__JF5Iq"};